import { PP_TABS } from '../pp.component';
import { FP_URLS_FULL_PATH } from '../../../../fund-performance/component/fund-performances/pojo/FP_URLS';

export const PP_URLS = {
  base: 'portfolios',
  _overview: 'overview',
  _analytics: 'analysis',
  _investment: 'investment',
  _with_appreciation: 'with-appreciation',
  _soi: 'soi',
  _details: 'details',
  _cashflow_matrix: 'cashflow-matrix',
  _cash_on_cash: 'cash-on-cash',
  _valuationBasis: 'basis',
  _comparison: 'periods-comparison',
  _insights: 'analytics',
};

export const PP_OVERVIEW_URL = `${FP_URLS_FULL_PATH.FUND}/${PP_URLS.base}/${PP_URLS._overview}`;
export const PP_BASE_URL = `${FP_URLS_FULL_PATH.FUND}/${PP_URLS.base}`;

export class PPTab {
  all: PP_TABS[];
  selected = 0;

  constructor(url: string) {
    this.initTabs(url);
  }

  initTabs(url: string): void {
    this.all = [PP_TABS.OVERVIEW, PP_TABS.INSIGHTS];
    this.selected = 0;
    this.changeTabByPath(url);
  }

  changeTabByPath(url: string): void {
    if (!url) {
      return;
    }
    let name: PP_TABS;
    switch (url) {
      case PP_URLS._overview:
        name = PP_TABS.OVERVIEW;
        break;
      case PP_URLS._analytics:
      case PP_URLS._soi:
      case PP_URLS._valuationBasis:
      case PP_URLS._investment:
      case PP_URLS._with_appreciation:
      case PP_URLS._details:
      case PP_URLS._insights:
      case PP_URLS._cashflow_matrix:
      case PP_URLS._cash_on_cash:
        name = PP_TABS.INSIGHTS;
        break;


    }
    // If there is no portfolio, there is only one tab -> Company Performance, which has the index of 0.
    const selectedTabIndex = this.all.indexOf(name);
    this.selected = this.all.length === 1 || selectedTabIndex === -1 ? null : selectedTabIndex;
  }
}
